import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { onlyNumberRegex } from '@shared/constants/regex.const';

export const sumFields = <T extends object>(obj: T, fields: string[], baseValue = 0): number => {
    return fields.reduce((sum, f) => sum + toNum(obj[f]), baseValue);
};

export const toNum = (v: unknown) => {
    if (isNilOrEmpty(v) || typeof v === 'object' || v instanceof Date) {
        return null;
    }

    if (typeof v === 'boolean') {
        return v ? 1 : 0;
    }

    const s = String(v);
    const n = Number(s.replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
};

export const isIntegerString = (value: string): boolean => {
    if (isNilOrEmpty(value) || !onlyNumberRegex.test(value)) {
        return false;
    }
    const n = Number(value);
    return Number.isSafeInteger(n);
};

export const numToStr = (n: number): string => n.toString(10).replace('.', ',');


export const roundHalfToEven = (value: number, decimals = 2): number => {
    const factor = 10 ** decimals;
    const scaled = Number((value * factor).toFixed(8));
    const floor = Math.floor(scaled);
    const diff = scaled - floor;

    if (Math.abs(diff - 0.5) < 1e-8) {
        return (floor % 2 === 0 ? floor : floor + 1) / factor;
    }
    return Math.round(scaled) / factor;
};
